import {createGlobalStyle} from 'styled-components';

export const FONT_FAMILIES = {
  Lato: {style: 'Lato, Helvetica, sans-serif', resources: []},
  Arial: {style: 'Arial, Helvetica, sans-serif', resources: []},
  Helvetica: {style: 'Helvetica, Arial, sans-serif', resources: []},
  Tahoma: {style: 'Tahoma, Geneva, sans-serif', resources: []},
  Verdana: {style: 'Verdana, Geneva, sans-serif', resources: []},
  'Times New Roman': {style: '"Times New Roman", Times, serif', resources: []},
  Courier: {style: '"Courier New", Courier, monospace', resources: []},
  Lucida: {style: '"Lucida Console", Monaco, monospace', resources: []},
  Trebuchet: {style: '"Trebuchet MS", Helvetica, sans-serif', resources: []},
  Georgia: {style: 'Georgia, serif', resources: []},
  'Open Sans': {
    style: '"Open Sans", Helvetica, sans-serif',
    resources: ['https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i']
  },
  Roboto: {
    style: '"Roboto", Helvetica, sans-serif',
    resources: ['https://fonts.googleapis.com/css?family=Roboto:400,400i,700,700i']
  }
};

export const GlobalStyles = createGlobalStyle`
  :root {
    --react-international-phone-height: 56px;
  }
`;
